/* ============================================================================
   THEMES-01 (+ PALETTE-QA-FIX-01) · Puente de tokens para Ant Design
   NO es la fuente de verdad visual — eso es src/styles/theme-tokens.css. Aquí
   sólo viven los valores que antd necesita EN JS para generar sus estilos y los
   de sus portales (Modal/Drawer/Select/Dropdown/DatePicker/Tooltip/Table/
   Pagination). Deben mantenerse alineados con theme-tokens.css.
   ========================================================================== */

const FONT_FAMILY =
  '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

export const ANTD_TOKENS = {
  clinical: {
    colorPrimary: "#326ea8",
    colorInfo: "#326ea8",
    colorSuccess: "#197a54",
    colorWarning: "#96590a",
    colorError: "#c0392b",
    colorBgBase: "#ffffff",
    colorTextBase: "#243244",
    colorBorder: "#dce4ec",
    colorBorderSecondary: "#e7edf3",
    colorBgLayout: "#f1f5f9",
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    borderRadius: 8,
    fontFamily: FONT_FAMILY,
  },
  blue: {
    colorPrimary: "#2f6fac",
    colorInfo: "#2f6fac",
    colorSuccess: "#197a54",
    colorWarning: "#96590a",
    colorError: "#c0392b",
    colorBgBase: "#ffffff",
    colorTextBase: "#233446",
    colorBorder: "#d6e2ec",
    colorBorderSecondary: "#e1eaf3",
    colorBgLayout: "#edf4fa",
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    borderRadius: 8,
    fontFamily: FONT_FAMILY,
  },
  dark: {
    colorPrimary: "#69a7d8",
    colorInfo: "#69a7d8",
    colorSuccess: "#46b98c",
    colorWarning: "#d79b45",
    colorError: "#e27366",
    colorBgBase: "#1c242e",
    colorTextBase: "#e7ecf2",
    colorBorder: "#344251",
    colorBorderSecondary: "#2b3743",
    colorBgLayout: "#151b23",
    colorBgContainer: "#1c242e",
    colorBgElevated: "#1e2732",
    borderRadius: 8,
    fontFamily: FONT_FAMILY,
  },
};

/* Component tokens para <Table> — coherentes con el contrato de tablas de
   theme-tokens.css (--table-*). Sin !important, sin CSS extra. */
export const ANTD_TABLE_TOKENS = {
  clinical: {
    headerBg: "#eef3f8",
    headerColor: "#33475c",
    headerSortActiveBg: "#e4edf5",
    headerSortHoverBg: "#e9f0f7",
    colorBgContainer: "#ffffff",
    colorText: "#243244",
    rowHoverBg: "#eef3fa",
    rowSelectedBg: "#e1eef9",
    rowSelectedHoverBg: "#d8e8f6",
    borderColor: "#e2e8f0",
    footerBg: "#eef3f8",
    footerColor: "#33475c",
  },
  blue: {
    headerBg: "#eef3f9",
    headerColor: "#2e4257",
    headerSortActiveBg: "#e3edf6",
    headerSortHoverBg: "#e8f0f8",
    colorBgContainer: "#ffffff",
    colorText: "#233446",
    rowHoverBg: "#edf3f9",
    rowSelectedBg: "#e1edf8",
    rowSelectedHoverBg: "#d6e6f5",
    borderColor: "#e1e8f0",
    footerBg: "#eef3f9",
    footerColor: "#2e4257",
  },
  dark: {
    headerBg: "#252f3b",
    headerColor: "#c7d0da",
    headerSortActiveBg: "#2b3644",
    headerSortHoverBg: "#28323f",
    colorBgContainer: "#1c242e",
    colorText: "#e7ecf2",
    rowHoverBg: "#293644",
    rowSelectedBg: "#26384b",
    rowSelectedHoverBg: "#2d4155",
    borderColor: "#344251",
    footerBg: "#252f3b",
    footerColor: "#c7d0da",
  },
};

/**
 * Devuelve el objeto `theme` para <ConfigProvider theme={...}>.
 * @param {"clinical"|"blue"|"dark"} resolvedTheme
 * @param {{ defaultAlgorithm: unknown, darkAlgorithm: unknown }} algorithms  el
 *        export `theme` de antd (`import { theme } from "antd"`).
 */
export function getAntdThemeConfig(resolvedTheme, algorithms) {
  const key = ANTD_TOKENS[resolvedTheme] ? resolvedTheme : "clinical";
  const token = ANTD_TOKENS[key];
  const tableToken = ANTD_TABLE_TOKENS[key];
  const algorithm =
    key === "dark" ? algorithms.darkAlgorithm : algorithms.defaultAlgorithm;
  return {
    algorithm,
    token,
    components: {
      Table: tableToken,
      Pagination: { colorText: token.colorTextBase },
    },
  };
}
